export class RiskSource {
    RiskSourceId: number;
    Source: string;
}
export class RiskMOCTypes {
    MOCTypeId: number;
    MOCType: string;
}
export class RiskChangeCategory {
    MOCChangeCategoryId: number;
    MOCChangeCategory: string;
}
      
export class Project {
    ProjectId: number;
    ProjectName: string;
}
 
export class RiskManagementTool {
    RiskManagementToolId: number;
    ToolName: string;
}

export class RiskControlTechniques {
    RiskControlTechniquesId: number;
    ControlTechnique: string;
}

export class RiskMovement {
    RiskMovementId: number;
    RiskMovementName: string;
}

export class RaiseRiskAllMaster {
    RiskSource: RiskSource[] = [];
    RiskMOCTypes: RiskMOCTypes[] =[];
    RiskChangeCategory:RiskChangeCategory[]=[];
    Project: Project[] = [];
    RiskManagementTool: RiskManagementTool[] = [];
    RiskControlTechniques: RiskControlTechniques[] = [];
    RiskMovement:RiskMovement[] = [];
}
